import React, { Component } from 'react';

class FourZeroThree extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount = () => {
    setTimeout(function(){ window.location.href = "/" }, 2500);
  }


  render() {
    return(
      <div id="notfound">
        <div class="notfound">
          <div class="notfound-404">
            <h1>403</h1>
          </div>
          <h2 className = "h2404">You do not have permission to view this page!</h2>
          <p>You will be redirected shortly</p>
          <a href="/">Home</a>
        </div>
      </div>
  );
  }

}
export default FourZeroThree;



// WEBPACK FOOTER //
// ./src/Components/FourZeroThree.js